import { IndexeddbAudioBackup } from "./IndexeddbAudioBackup";
import * as AudioBackup from "../interfaces/IAudioBackup";
import { AudioBackupError, AudioBackupErrors } from "./AudioBackupErrors";
import { ErrorStringFromException } from "../../utils/utils";

export function CreateDefaultAudioBackup(): AudioBackup.IAudioBackup {
    return CreateAudioBackup(AudioBackup.SupportedBackends.indexeddb);
}

function CreateAudioBackup(backendToUse: AudioBackup.SupportedBackends): AudioBackup.IAudioBackup {
    let backup: AudioBackup.IAudioBackup = null;
    switch (backendToUse) {
        case AudioBackup.SupportedBackends.indexeddb:
            try {
                if (window.indexedDB == null) {
                    throw new AudioBackupError(AudioBackupErrors.UnsupportedBrowser, 'Null indexeddb found, browser unsupported')
                }
            } catch (e) {
                throw new AudioBackupError(AudioBackupErrors.UnsupportedBrowser, 'Null indexeddb found, browser unsupported. ' + ErrorStringFromException(e));
            }

            backup = new IndexeddbAudioBackup(window.indexedDB);
            break;
        default:
            throw new Error("Unknown backendToUse: " + backendToUse);
    }

    return backup;
}